// Dialogs and drawers (#1205): Tailwind Plus <el-dialog> markup around a native <dialog>, opened
// and closed by the dialog's id. el-dialog handles focus, Esc and a click on the backdrop.
function wrapper(id) {
  return document.getElementById(id)?.closest("el-dialog") || null;
}

export function isDialog(id) {
  return document.getElementById(id)?.tagName === "DIALOG";
}

// Showing an open one again does nothing, so a drawer can refill itself in place (the ingredient
// inspector following a substitute link, #1206).
export function showDialog(id) {
  const dialog = document.getElementById(id);
  if (!dialog || dialog.open) return;
  const el = wrapper(id);
  if (typeof el?.show === "function") el.show();
  else dialog.showModal?.();
}

export function hideDialog(id) {
  const dialog = document.getElementById(id);
  if (!dialog?.open) return;
  const el = wrapper(id);
  if (typeof el?.hide === "function") el.hide();
  else dialog.close();
}
